import { jsx as _jsx } from "react/jsx-runtime";
import { TableHeading } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Table';
import { buildElementStyling } from '../utils';
export const renderedTableHeadings = {};
const RichTextTableHeading = ({ children, value, index }) => {
    const { className, style } = buildElementStyling({
        baseClass: 'richTextTableHeading',
        value,
    });
    renderedTableHeadings[index] = children === null || children === void 0 ? void 0 : children[0];
    return (_jsx(TableHeading, { className: className, style: style, styleAs: "paragraphSmall", children: children }));
};
RichTextTableHeading.displayName = 'RichTextTableHeading';
export default RichTextTableHeading;
//# sourceMappingURL=TableHeading.js.map